export interface RequestedCompanyIndicators {
  pageId: string;
  vat: string;
}

const STORAGE_KEY = 'osservio:requested-company-indicators';

function isRequestedCompany(value: unknown): value is RequestedCompanyIndicators {
  if (!value || typeof value !== 'object') return false;
  const row = value as Record<string, unknown>;
  return typeof row.pageId === 'string' && row.pageId.length > 0
    && typeof row.vat === 'string' && row.vat.length > 0;
}

export function readRequestedCompanyIndicators(): RequestedCompanyIndicators[] {
  try {
    const parsed: unknown = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter(isRequestedCompany) : [];
  } catch {
    return [];
  }
}

export function rememberRequestedCompanyIndicators(pageId: string, vat: string): void {
  const normalizedVat = vat.replace(/\s+/g, '').toUpperCase();
  if (!pageId || !normalizedVat) return;
  const previous = readRequestedCompanyIndicators().filter((row) => row.pageId !== pageId);
  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify([{ pageId, vat: normalizedVat }, ...previous].slice(0, 50)),
  );
}
